import { FC } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const MainLayout: FC = () => {
  return (
    <>
      <Header />
      <Box component="main" minHeight="calc(100vh - var(--header-height))">
        <Outlet />
      </Box>
      <Footer />
    </>
  );
};

export default MainLayout;
